/**
 * @type interface
 */
export interface IStoreState {
	latitude: number;
	longitude: number;
	timestamp: number;
}

/**
 * @class State
 * @package Store/Module/Location
 * @project ChalkySticks App
 */
const state: IStoreState = {
	latitude: 0,
	longitude: 0,
	timestamp: 0,
};

export default state;
